import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RowActions } from 'src/app/dashboard/admin/report/report';
import { MerchantListService } from 'src/app/dashboard/admin/report/services/gate-services/merchant-list.service';
import Swal from 'sweetalert2';
import { BaseGateReportListComponent } from '../../baseReport.component';
import { MerchantDeleteService } from '../../services/merchant-delete.service';

@Component({
  selector: 'app-gate-merchant-list',
  templateUrl: './gate-merchant-list.component.html',
  styleUrls: ['./gate-merchant-list.component.scss'],
})
export class GateMerchantListComponent
  extends BaseGateReportListComponent
  implements OnInit {
  displayTableColumns: { [key: string]: string } = {
    name: 'Name',
    email: 'Email',
    mobile: 'Mobile',
    createdAt: 'Created At',
  };
  properties = ['name', 'email', 'mobile', 'createdAt'];
  selectFilters = [];
  data;
  actions: RowActions[] = [
    {
      actionName: 'delete',
      actionType: 'icon',
      iconClass: 'fa fa-trash',
    },
    {
      actionName: 'edit',
      actionType: 'icon',
      iconClass: 'fa fa-edit',
    },
  ];
  totalRecords: number;
  itemsPerPage: number = 10;

  constructor(
    private merchantList: MerchantListService,
    private merchantDelete: MerchantDeleteService,
    private route: Router,
    private cdr: ChangeDetectorRef,
    private activeRoute: ActivatedRoute
  ) {
    super();
    this.requestBody.columns = this.properties;
  }

  async ngOnInit() {
    await this.updateTable();
  }
  async updateTable() {
    this.merchantList.setParams(this.requestBody);
    let responseData = await this.merchantList.make();
    this.totalRecords = responseData.count;
    this.data = responseData.merchants;
    this.cdr.detectChanges();
  }

  actionEmiter(event) {
    console.log(event);
    switch (event.action) {
      case 'delete':
        this.deleteProvider(event.key.id);
        break;

      case 'edit':
        this.editProvider(event.key.id);
        break;
      default:
        break;
    }
  }

  async deleteProvider(id: number) {
    Swal.fire({
      title: 'Are you sure you want to delete this Merchant?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(async (result) => {
      if (result.value) {
        this.merchantDelete.setParams({ id });
        let responseData = await this.merchantDelete.make();
        if (responseData.success) {
          await this.updateTable();
        }
      }
    });
  }

  async editProvider(id: number) {
    this.route.navigate([`edit/${id}`], { relativeTo: this.activeRoute });
  }
}
